import styled from 'styled-components';
import { media } from 'designsystem';

const Image = styled.img`
    width: 100%;
    display: block;
    margin: 0 auto;
    position: relative;
    ${media.desktop`
        width: 80%;
    `};
`;

export default Image;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Banner/Image.jsx